// extracted by mini-css-extract-plugin
export default {"privacyRoot":"PrivacyPolicy_privacyRoot__I7zZv","privacyContainer":"PrivacyPolicy_privacyContainer__C2vLA","privacyTitle":"PrivacyPolicy_privacyTitle__TuDze"};